import { render, staticRenderFns } from "./viewPromoOutlets.vue?vue&type=template&id=24a95e14&scoped=true&"
import script from "./viewPromoOutlets.vue?vue&type=script&lang=js&"
export * from "./viewPromoOutlets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a95e14",
  null
  
)

export default component.exports